import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LandedPage } from './pages/LandedPage';
import { SarahPage } from './pages/SarahPage';
import { JasonPage } from './pages/JasonPage';
import { MayaPage } from './pages/MayaPage';
import { KoaPage } from './pages/KoaPage';
import { SignupPage } from './pages/SignupPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandedPage />} />
        <Route path="/sarah" element={<SarahPage />} />
        <Route path="/jason" element={<JasonPage />} />
        <Route path="/maya" element={<MayaPage />} />
        <Route path="/koa" element={<KoaPage />} />
        <Route path="/signups" element={<SignupPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;